import {useCallback, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {mergeUsersToParticipants} from '../../misc/mergeUsersToParticipants';
import {useEventConnections} from '../connections/useEventConnections';
import {useMeetingRelatedUsers} from '../meeting/useMeetingRelatedUsers';
import {useQARelatedUsers} from '../questions/useQARelatedUsers';

/**
 * Returns all event participants
 * @param {Number} eventId Event ID
 * @returns {Array} List of all participants (including user connections)
 */
export function useEventParticipants(eventId, options = {}) {
    const {connections: listConnections = true, meetings: listMeetings = true, qa: listQA = true} = options,
        selector = useCallback(state => state.events[eventId]?.participants?.listed, [eventId]),
        participants = useSelector(selector) ?? [],
        connections = useEventConnections(eventId),
        meetingUsers = useMeetingRelatedUsers(eventId),
        qaUsers = useQARelatedUsers(eventId);

    return useMemo(
        () =>
            mergeUsersToParticipants(
                [...participants],
                [...(listConnections ? connections : []), ...(listMeetings ? meetingUsers : []), ...(listQA ? qaUsers : [])]
            ),
        [participants, connections, meetingUsers]
    );
}
